import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-to_do",
  "use": "icon-to_do-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-to_do\"><g transform=\"matrix(1,0,0,-1,0,28)\"><path d=\"M7,28Q8.91406,27.9727,10.5,27.0703Q12.0859,26.1406,13.0703,24.5Q14,22.83203,14,21Q14,19.16797,13.0703,17.5Q12.0859,15.85938,10.5,14.929688Q8.91406,14.0273438,7,14Q5.08594,14.0273438,3.5,14.929688Q1.91406,15.85938,0.929688,17.5Q0,19.16797,0,21Q0,22.83203,0.929688,24.5Q1.91406,26.1406,3.5,27.0703Q5.08594,27.9727,7,28ZM6.34375,24.7188L6.34375,21L6.34375,24.7188L6.34375,21Q6.34375,20.64453,6.64453,20.45312L9.26953,18.70312Q9.78906,18.40234,10.1719,18.89453Q10.4727,19.41406,9.98047,19.79688L7.65625,21.35547L7.65625,24.7188Q7.60156,25.3203,7,25.375Q6.39844,25.3203,6.34375,24.7188Z\" fill=\"#6C5FFC\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/to_do.svg
// module id = ZEe5
// module chunks = 119